import * as R from 'ramda'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirestore } from 'react-redux-firebase'
import { withHandlers } from 'recompose'
import { compose } from 'redux'

import {
  dataFromOrdered,
  findInOrdered,
  fsCollections,
  makeInBatchWithFirebase,
} from '../../helpers/firestore'
import { flightResults, resultKey } from '../../helpers/results'
import { spinnerWhileLoading } from '../higher-order/spinner'

import * as notificationActions from '../../actions/notifications'

const createFlightResultWrapper = (FlightResultView) => (props) => {
  const { flight, tournamentPlayers, tournamentResults, playground } = props

  return (
    <FlightResultView
      {...props}
      flightResults={flightResults(flight, tournamentPlayers, tournamentResults, playground.holes)}
    />
  )
}

export default (FlightResultView) =>
  compose<FIXME>(
    withFirestore,
    firestoreConnect<FIXME>(({ tenant, tournamentId, flightId }) => [
      { collection: fsCollections.tournaments(tenant), doc: tournamentId },
      { collection: fsCollections.tournamentFlights(tenant, tournamentId) },
      { collection: fsCollections.tournamentPlayers(tenant, tournamentId) },
      { collection: fsCollections.tournamentResults(tenant, tournamentId) },
    ]),
    withHandlers<FIXME, FIXME>({
      inBatchBound: makeInBatchWithFirebase,
      saveResultsError: ({ dispatch }) => (err) => {
        // tslint:disable-next-line:no-console
        console.error(err)
        dispatch(notificationActions.notifyFailure('Failed to save results data'))
      },
      saveResultsSuccess: ({ dispatch }) => () => {
        dispatch(notificationActions.notifySuccess('Succesfully saved results data'))
      },
    }),
    withHandlers({
      saveAllResultsInFlight: ({
        tenant,
        tournamentId,
        playground,
        saveResultsSuccess,
        saveResultsError,
        inBatchBound,
      }) => (flight, resultsByHoles) =>
        inBatchBound((firestore, batch) => {
          const collection = firestore.collection(
            fsCollections.tournamentResults(tenant, tournamentId),
          )
          flight.players.forEach((playerId) => {
            const id = resultKey(playerId, flight.round)
            const results = resultsByHoles.map((result) => result[playerId])
            batch.set(collection.doc(id), {
              id,
              round: flight.round,
              playerId,
              results,
              currentHoleKey: playground.holes,
              isFinal: !R.isNil(flight.isFinal) && flight.isFinal,
            })
          })
        })
          .then((res) => saveResultsSuccess())
          .catch((err) => saveResultsError(err)),
    }),
    connect(({ firestore }: FIXME, { tenant, tournamentId, flightId }: FIXME) => ({
      tournament: findInOrdered(firestore.ordered[fsCollections.tournaments(tenant)], tournamentId),
      flight: findInOrdered(
        firestore.ordered[fsCollections.tournamentFlights(tenant, tournamentId)],
        flightId,
      ),
      tournamentPlayers: firestore.ordered[fsCollections.tournamentPlayers(tenant, tournamentId)],
      tournamentPlayersMap: dataFromOrdered(
        firestore.ordered[fsCollections.tournamentPlayers(tenant, tournamentId)],
      ),
      tournamentResults: firestore.ordered[fsCollections.tournamentResults(tenant, tournamentId)],
    })),
    spinnerWhileLoading(
      ({ tournament, flight, tournamentPlayers, tournamentPlayersMap, tournamentResults }) =>
        !isLoaded(tournament, flight, tournamentPlayers, tournamentPlayersMap, tournamentResults),
    ),
  )(createFlightResultWrapper(FlightResultView))



// WEBPACK FOOTER //
// ./src/components/tournament/prepareFlightResults.tsx